import { createReducer } from '@reduxjs/toolkit'

import { TFetchStatus } from 'redux/reducers/Dashboards'

import * as actions from '../../../actions/internal/Accounts/actions'
import * as authenticationActions from '../../../actions/Authentication/actions'

import { InternalAccount, InternalNpsPeriod } from 'types/GlobalInternalAccount'

export interface InternalAccountReducerType {
  data: Record<string, InternalAccount>
  fetchStatus: TFetchStatus
  // Apart from data, so the list fetch does not drop it.
  nps: Record<string, InternalNpsPeriod[]>
}

const INITIAL_STATE: InternalAccountReducerType = {
  data: {},
  fetchStatus: 'idle',
  nps: {}
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = Object.fromEntries(
        action.payload.map((account) => [account.id, account])
      )
      state.fetchStatus = 'success'
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(actions.getOneSuccess, (state, action) => {
      state.data[action.payload.id] = action.payload
    })
    .addCase(actions.getNpsSuccess, (state, action) => {
      state.nps[action.payload.id] = action.payload.periods
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})
